import React from "react";
import styled from "@emotion/styled";
import { CSSProperties } from "@emotion/serialize";
import { Typography } from "@kaltura/ds-react-components";
import { systemWidth } from "@kaltura/mediaspace-shared-styled";
import { HtmlReactParser } from "@kaltura/mediaspace-shared-utils";

export interface TextOnlyProps {
    text?: string;
    color?: CSSProperties["color"];
    backgroundColor?: CSSProperties["color"];
    isAlignedToCenter?: boolean;
}
const StyledTextOnlyWrapper = styled("div")(({ theme }) => ({
    "&": systemWidth({ theme }),
    display: "flex",
    justifyContent: "center",
}));

const StyledTextOnly = styled(
    Typography,
    {
        shouldForwardProp: (prop) => prop !== "isAlignedToCenter",
    }
)<TextOnlyProps>(({ theme, backgroundColor = "transparent", color = "textPrimary", isAlignedToCenter = true }) => ({
    color: color,
    backgroundColor: backgroundColor,
    display: "flex",
    flexDirection: "column",
    fontSize: theme.typography.pxToRem(24),
    lineHeight: theme.typography.pxToRem(34),
    textAlign: isAlignedToCenter ? "center" : undefined,
    flexGrow: 1,

    a: {
        fontSize: theme.typography.pxToRem(24),
    },
    "ul:not(:last-child), ol:not(:last-child)": {
        marginBottom: 0,
    },
    "ul:not(:first-child), ol:not(:first-child)": {
        marginTop: 0,
    },
    "ul, ol": {
        display: "inline-block", //make the UL element inline-block, ensures that it does not take up 100% of the width, allowing it to be centered within the parent
        textAlign: "start", // resets the text alignment to follow the natural reading direction of the text
        margin: isAlignedToCenter ? "0 auto" : undefined, // centers the UL element within its parent
        listStylePosition: "inside", // ensures that the list markers are inside the content box of the UL/OL element
    },
}));

/**
 *  TextOnly component shows text in the homepage
 */
export const TextOnly = (props: TextOnlyProps) => {
    const { text = "", color, backgroundColor, isAlignedToCenter = true } = props;

    return (
        <StyledTextOnlyWrapper className="kms-ds-homepage-component-textonly">
            <StyledTextOnly color={color} backgroundColor={backgroundColor} isAlignedToCenter={isAlignedToCenter}>
                {HtmlReactParser(text)}
            </StyledTextOnly>
        </StyledTextOnlyWrapper>
    );
};

export default TextOnly;
